import { CardModal } from '@components/LPCard/Common'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import { IPCardModal } from '@components/LPCard/Common/CardModal/interface'

const WhatModal: React.FC<IPCardModal> = ({ open, onClose }) => {
  return (
    <CardModal open={open} onClose={onClose}>
      <CardModal.Title>
        <FormattedMessage id="What is a review?" />
      </CardModal.Title>
      <CardModal.Desc>
        <FormattedMessage id="A review is an opportunity to improve your score by reviewing the lessons you've learnt." />
      </CardModal.Desc>
      <CardModal.CloseBtn onClick={() => onClose()}>
        <FormattedMessage id="Tap to close" />
      </CardModal.CloseBtn>
    </CardModal>
  )
}

export default WhatModal
